class HttpService {
    constructor() {
        this.baseUrl = `${process.env.REACT_APP_BACKEND_URL}`; // Replace with your API base URL
    }

    // Get auth headers, returning an array of [key, value] pairs for either client token or auth token
    getAuthHeaders() {
        let authToken = localStorage.getItem('auth_token');
        if (!authToken) {
            // If no auth token, check for or generate a unique client token
            let clientToken = localStorage.getItem('client_token');
            if (!clientToken) {
                clientToken = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
                localStorage.setItem('client_token', clientToken);
            }
            return [['X-Client-Token', clientToken]];
        }
        return [['X-Auth-Token', authToken]];
    }

    // Handle the response from the server
    async handleResponse(response) {

        return response;

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'An error occurred');
        }
        return response.json();
    }

    // Common method to handle HTTP requests
    async request(method, url, bodyOrParams = null) {
        const authHeaders = this.getAuthHeaders(); // Get auth headers as an array of [key, value] pairs

        // Initialize headers with default Content-Type
        const headers = {
            'Device-Type': 'web',
            'Content-Type': 'application/json',
            // ...bodyOrParams?.headers, // Uncomment if you want to allow custom headers
        };

        // Merge auth headers into the main headers object
        authHeaders.forEach(([key, value]) => {
            headers[key] = value;
        });

        let options = {
            method,
            headers,
        };

        // If the method is POST or PUT, include the body
        if (method === 'POST' || method === 'PUT') {
            options.body = JSON.stringify(bodyOrParams);
        }

        // If it's a GET or DELETE, append query parameters (empty for now, as per your comment)
        if (method === 'GET' || method === 'DELETE') {
            // const queryParams = ''; // You can reinstate URLSearchParams logic here if needed
            url = `${url}`;
        }

        const response = await fetch(`${this.baseUrl}${url}`, options);
        return this.handleResponse(response);
    }

    // GET request
    async get(url, params) {
        return this.request('GET', url, params);
    }

    // POST request
    async post(url, body) {
        return this.request('POST', url, body);
    }

    // PUT request
    async put(url, body) {
        return this.request('PUT', url, body);
    }

    // DELETE request
    async delete(url, params) {
        return this.request('DELETE', url, params);
    }
}

const httpService = new HttpService();
export default httpService;